import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage'

import { baseApi } from '../api/baseApi'
import { authReducer, feedReducer, messagesReducer } from '../reducers'
import settingsReducer from '../reducers/settings/setting.reducer'
import buysellReducer from '../reducers/profile/profile.reducer'
import buyETHReducer from '../reducers/wallet/wallet.reduce'
import exploreReducer from '../reducers/explore/explore.reduce'
import channelReducer from '../reducers/channel/channel.reducer'
import { w3Api } from '../api/w3Api'
import Web3Reducer from '../reducers/web3/web3.reduce'
import mySpaceReducer from '../reducers/web3/my-space/my-space.reducer'
import transactionsReducer from '../../hooks/transactions/reducer'
import { tempReducer } from '../reducers/temp'

const persistConfig = {
  key: 'root_v1',
  storage,
  timeout: 30000,
  // whitelist: [],
  // blacklist: [],
  stateReconciler: autoMergeLevel2,
}

const rootReducer = combineReducers({
  auth: authReducer,
  settings: settingsReducer,
  profile: buysellReducer,
  wallets: buyETHReducer,
  messages: messagesReducer,
  explore: exploreReducer,
  feeds: feedReducer,
  channel: channelReducer,
  web3: Web3Reducer,
  myspace: mySpaceReducer,
  transactions: transactionsReducer,
})

type RootState = ReturnType<typeof rootReducer>
const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer)

const channel = new BroadcastChannel('redux-sync')

let isBroadcasting = false

// 4. Broadcast Middleware
const broadcastMiddleware = (store: any) => (next: any) => (action: any) => {
  const result = next(action)
  if (!isBroadcasting && action.type === 'auth/setLocalSocial') {
    const state = store.getState()
    channel.postMessage(state)
    return result
  }
  return null
}

export const store = configureStore({
  reducer: {
    root: persistedReducer,
    [baseApi.reducerPath]: baseApi.reducer,
    [w3Api.reducerPath]: w3Api.reducer,
    temp: tempReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(baseApi.middleware, w3Api.middleware, broadcastMiddleware),

  devTools: process.env.mode !== 'production',
})

channel.onmessage = (event) => {
  isBroadcasting = true // Bắt đầu xử lý đồng bộ
  store.dispatch({ type: 'auth/setUser', payload: event?.data?.root.auth.user })
  isBroadcasting = false // Hoàn tất xử lý
}
export const persistor = persistStore(store)
